export default {
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },
      header: {
        type: String
      }
    },
    data() {
      return {
        height: 0
      }
    },
    methods: {
      toggleIsOpen() {
        this.isOpen = !this.isOpen
        this.$dispatch('isOpenEvent', this)
      }
    },
    ready() {
      const panel = this.$els.panel
      panel.style.display = 'block'
      this.height = panel.offsetHeight
      panel.style.maxHeight = this.height + 'px'
      if (!this.isOpen) panel.style.display = 'none'
    }
  }


/** WEBPACK FOOTER **
 ** ./src/Panel.vue
 **/